var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { Getter, namespace, State } from 'vuex-class';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import NumberRange from '~/components/common/number-range.vue';
import { LegalCaseManageService } from '~/services/domain-service/legal-case-manage.service';
import { MENU_CHANNEL } from '~/config/enum.config';
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
var CollectionExecutionModule = namespace('collection-execution');
var LegalSettleCaseManage = /** @class */ (function (_super) {
    __extends(LegalSettleCaseManage, _super);
    function LegalSettleCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            currentCollectorRealName: '',
            partnerName: '',
            batchNumber: ''
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        return _this;
    }
    LegalSettleCaseManage.prototype.created = function () {
        this.refreshData();
    };
    LegalSettleCaseManage.prototype.refreshData = function () {
        var _this = this;
        this.legallyCaseManageServiceTestG
            .settleCasePool(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    LegalSettleCaseManage.prototype.departemntChange = function (id, code) { };
    LegalSettleCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        return params;
    };
    /**
     * 表单范围输入框重置
     */
    LegalSettleCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
        this.model.personalCollectionRemainingDays = { min: '', max: "" };
    };
    /**
     * 进入查看执行页
     */
    LegalSettleCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Legal_settle,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    __decorate([
        Dependencies(PageService)
    ], LegalSettleCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LegalSettleCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], LegalSettleCaseManage.prototype, "legallyCaseManageServiceTestG", void 0);
    __decorate([
        CollectionExecutionModule.Action
    ], LegalSettleCaseManage.prototype, "openCollectionExecution", void 0);
    __decorate([
        Getter
    ], LegalSettleCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], LegalSettleCaseManage.prototype, "updateCollectionSign", void 0);
    __decorate([
        State
    ], LegalSettleCaseManage.prototype, "principalList", void 0);
    LegalSettleCaseManage = __decorate([
        Auth(305),
        Layout('workspace'),
        Component({
            components: {
                NumberRange: NumberRange,
                GetLabelName: GetLabelName,
                SelectDepartment: SelectDepartment
            },
        })
    ], LegalSettleCaseManage);
    return LegalSettleCaseManage;
}(Vue));
export default LegalSettleCaseManage;
